module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/f4473b594bb6b8ef7266f7b37f4392e5.png";